import Header from "../components/landing/Header";
import HeroLeadFotowoltaika from "../components/landing/HeroLeadFotowoltaika";
import TrustStrip from "../components/landing/TrustStrip";
import BenefitsListSection from "../components/landing/BenefitsListSection";
import HowItWorksFotowoltaika from "../components/landing/HowItWorksFotowoltaika";
import MicroProofFotowoltaika from "../components/landing/MicroProofFotowoltaika";
import FAQFotowoltaika from "../components/landing/FAQFotowoltaika";
import FinalCTAFotowoltaika from "../components/landing/FinalCTAFotowoltaika";
import Footer from "../components/landing/Footer";
import MobileStickyCTA from "../components/landing/MobileStickyCTA";
import { PageProvider } from "../config/PageContext";
import { Lightbulb, BadgeCheck, Hammer } from "lucide-react";

const NAV_LINKS = [
  { id: "dlaczego", label: "Dlaczego warto" },
  { id: "jak-to-dziala", label: "Jak to działa" },
  { id: "faq", label: "FAQ" },
];

const TRUST_ITEMS = [
  { icon: Lightbulb, label: "Jasny proces montażu" },
  { icon: BadgeCheck, label: "Bezpłatna konsultacja" },
  { icon: Hammer, label: "Montaż nawet w 21 dni" },
];

const FOOTER_NAV_LINKS = [
  { id: "jak-to-dziala", label: "Jak to działa" },
  { id: "faq", label: "FAQ" },
];

const FOOTER_DESCRIPTION =
  "Heliora realizuje montaż fotowoltaiki we współpracy z certyfikowanymi partnerami montażowymi.";

export default function FotowoltaikaPage() {
  return (
    <PageProvider value="FOTOWOLTAIKA">
      <div
        className="min-h-screen bg-white text-brand-ink font-body overflow-x-hidden"
        data-testid="fotowoltaika-page"
      >
        <Header ctaLabel="Zostaw numer" navLinks={NAV_LINKS} />
        <main>
          <HeroLeadFotowoltaika />
          <TrustStrip items={TRUST_ITEMS} />
          <BenefitsListSection />
          <HowItWorksFotowoltaika />
          <MicroProofFotowoltaika />
          <FAQFotowoltaika />
          <FinalCTAFotowoltaika />
        </main>
        <Footer description={FOOTER_DESCRIPTION} navLinks={FOOTER_NAV_LINKS} />
        <MobileStickyCTA label="Zostaw numer" />
      </div>
    </PageProvider>
  );
}
